import { html } from '@shared/utils/rendering/html';
import UserDetails from './user-details';
import UsersTable from './users-table';

const AdminUsers = ({ userId }) => {
    if (userId) {
        return html`<${UserDetails} userId=${userId} />`;
    }

    return html`<${UsersTable} />`;
};

export default AdminUsers;
